export default __webpack_public_path__ + "static/bruce-97ea38442a967b3123257c93ebe7afef.png";